// extracted by mini-css-extract-plugin
module.exports = {"container":"container_2x38j6","kangaroo-info":"kangaroo-info_vx23Lf","kangarooInfo":"kangaroo-info_vx23Lf","kangarooImg":"kangarooImg_3bAX-H","link":"link_1SNCE7"};